export default __webpack_public_path__ + "static/media/Options_icon.59fe3c5b.svg";